module.exports = __webpack_public_path__ + "static/browse1-d790840ecc0ecd039f305419d4753058.png";